import React, { useState } from 'react';
import Icon from '../components/Icon';
import '../styles/ReviewForm.css';

const RATING_LABELS = {
  1: { text: 'Slabo' },
  2: { text: 'Moglo byc lepiej' },
  3: { text: 'Dobrze' },
  4: { text: 'Bardzo dobrze!' },
  5: { text: 'Doskonale!' },
};

const CATEGORIES = [
  { key: 'service',     icon: 'scissors', label: 'Jakosc uslugi'     },
  { key: 'cleanliness', icon: 'salon',    label: 'Czystosc salonu'   },
  { key: 'staff',       icon: 'user',     label: 'Obsluga personelu' },
  { key: 'atmosphere',  icon: 'heart',    label: 'Atmosfera'         },
];

const ReviewForm = ({ booking, onSubmit, onCancel }) => {
  const [rating, setRating]         = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [comment, setComment]       = useState('');
  const [categories, setCategories] = useState({ service: 0, cleanliness: 0, staff: 0, atmosphere: 0 });
  const [catHover, setCatHover]     = useState({});
  const [submitted, setSubmitted]   = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (rating === 0) return;
    setSubmitted(true);
    setTimeout(() => {
      onSubmit({
        id: Date.now(),
        bookingId: booking.id,
        salonId: booking.salon?.id,
        salonName: booking.salon?.name,
        userId: booking.userId,
        rating, comment, categories,
        createdAt: new Date().toISOString(),
      });
    }, 800);
  };

  const activeRating = hoverRating || rating;

  return (
    <div className="review-overlay" onClick={(e) => e.target === e.currentTarget && onCancel()}>
      <div className="review-modal">

        {/* Ekran potwierdzenia */}
        {submitted && (
          <div className="review-success">
            <div className="success-icon">
              <Icon name="star" color="#f59e0b" size="3x" />
            </div>
            <h2>Dziekujemy za opinie!</h2>
            <p>Twoja ocena pomaga innym klientom w wyborze salonu.</p>
          </div>
        )}

        {!submitted && (
          <>
            {/* Nagłówek */}
            <div className="review-header">
              <div>
                <h2>Oceń wizytę</h2>
                <p className="review-salon-name">
                  <Icon name="scissors" style={{marginRight:'7px'}} />
                  {booking.salon?.name}
                </p>
              </div>
              <button className="review-close-btn" onClick={onCancel}>
                <Icon name="close" />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="review-form">

              {/* Podsumowanie rezerwacji */}
              <div className="review-booking-summary">
                <span><Icon name="calendar" style={{marginRight:'7px'}} />{booking.date} o {booking.time}</span>
                <span><Icon name="user" style={{marginRight:'7px'}} />{booking.employee?.name}</span>
                <span><Icon name="scissors" style={{marginRight:'5px'}} />{booking.services?.map(s => s.name).join(', ')}</span>
              </div>

              {/* Główna ocena */}
              <div className="review-main-rating">
                <label>Ogólna ocena *</label>
                <div className="stars-large" onMouseLeave={() => setHoverRating(0)}>
                  {[1,2,3,4,5].map(star => (
                    <span
                      key={star}
                      className={`star-large ${star <= activeRating ? 'active' : ''}`}
                      onClick={() => setRating(star)}
                      onMouseEnter={() => setHoverRating(star)}
                    />
                  ))}
                </div>
                {activeRating > 0 && (
                  <div className="rating-label">
                    <Icon name="star" color="#f59e0b" style={{marginRight:'8px'}} />
                    <span className="rating-text">{RATING_LABELS[activeRating].text}</span>
                  </div>
                )}
              </div>

              {/* Oceny szczegółowe */}
              <div className="review-categories-section">
                <h3>Szczegółowe oceny <span className="optional-tag">(opcjonalne)</span></h3>
                {CATEGORIES.map(({ key, icon, label }) => (
                  <div key={key} className="category-row"
                    onMouseLeave={() => setCatHover(p => ({ ...p, [key]: 0 }))}>
                    <span className="category-label">
                      <Icon name={icon} style={{marginRight:'7px', color:'#1e3c72'}} />
                      {label}
                    </span>
                    <div className="stars-small-row">
                      {[1,2,3,4,5].map(star => (
                        <span
                          key={star}
                          className={`star-small ${star <= (catHover[key] || categories[key]) ? 'active' : ''}`}
                          onClick={() => setCategories(p => ({ ...p, [key]: star }))}
                          onMouseEnter={() => setCatHover(p => ({ ...p, [key]: star }))}
                        />
                      ))}
                      {categories[key] > 0 && (
                        <span className="cat-val">{categories[key]}/5</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* Komentarze */}
              <div className="review-comment-section">
                <label>Komentarz <span className="optional-tag">(opcjonalnie)</span></label>
                <textarea
                  value={comment}
                  onChange={e => setComment(e.target.value.slice(0, 500))}
                  placeholder="Podziel sie wrazeniami z wizyty..."
                  rows={4}
                  className="review-textarea"
                />
                <span className="char-counter">{comment.length}/500</span>
              </div>

              {/* Akcje */}
              <div className="review-actions">
                <button type="button" className="review-cancel-btn" onClick={onCancel}>
                  Anuluj
                </button>
                <button type="submit" className="review-submit-btn" disabled={rating === 0}>
                  {rating === 0
                    ? 'Wybierz ocene'
                    : <><Icon name="send" style={{marginRight:'8px'}} />Wyslij opinie</>
                  }
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ReviewForm;
